(() => {
  'use strict';
  const mobile = document.querySelector('#mobile-nav-dialog');
  const search = document.querySelector('#nav-search-dialog');
  const opener = document.querySelector('.mobile-nav-open');
  const disclosure = document.querySelector('.nav-disclosure');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 1101px)');
  const previousFocus = new WeakMap();

  function close(dialog) {
    if (dialog?.open) dialog.close();
  }
  function closeDesktop() {
    if (disclosure) disclosure.open = false;
  }
  function open(dialog, trigger) {
    if (!dialog || dialog.open) return;
    closeDesktop();
    previousFocus.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    document.body.classList.add('modal-open');
    if (dialog === mobile) opener?.setAttribute('aria-expanded', 'true');
    const focusTarget = dialog === search ? dialog.querySelector('input') : dialog.querySelector('.nav-close');
    focusTarget?.focus({ preventScroll: true });
    if (!reduce.matches && typeof dialog.animate === 'function') {
      dialog.animate(dialog === mobile ? [
        { opacity: .65, transform: 'translateX(-26px)' }, { opacity: 1, transform: 'translateX(0)' }
      ] : [
        { opacity: .7, transform: 'translateY(-12px)' }, { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 260, easing: 'cubic-bezier(.2,.7,.3,1)' });
    }
  }
  [mobile, search].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
      if (dialog === mobile) opener?.setAttribute('aria-expanded', 'false');
      const target = previousFocus.get(dialog);
      if (target?.isConnected && !target.closest('dialog:not([open])')) target.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
    });
  });
  opener?.addEventListener('click', () => open(mobile, opener));
  document.querySelectorAll('.nav-search-open').forEach(trigger => trigger.addEventListener('click', event => {
    if (!search) return;
    event.preventDefault();
    const returnTarget = trigger.closest('#mobile-nav-dialog') ? opener : trigger;
    close(mobile);
    open(search, returnTarget);
  }));
  document.querySelectorAll('[data-close-navigation]').forEach(button => button.addEventListener('click', () => close(button.closest('dialog'))));
  mobile?.querySelectorAll('a:not(.nav-search-open)').forEach(link => link.addEventListener('click', () => close(mobile)));
  search?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(search)));
  document.querySelector('.nav-search-form')?.addEventListener('submit', event => {
    event.preventDefault();
    const query = document.querySelector('#nav-search-query')?.value.trim() || '';
    window.location.href = `${window.MDMTheme?.searchUrl || '/search'}?type=product&q=${encodeURIComponent(query)}`;
  });
  if (disclosure) {
    const summary = disclosure.querySelector('summary');
    disclosure.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(disclosure.open)));
    disclosure.addEventListener('focusout', () => setTimeout(() => {
      if (!disclosure.contains(document.activeElement)) closeDesktop();
    }, 0));
    disclosure.querySelectorAll('a').forEach(link => link.addEventListener('click', closeDesktop));
    document.addEventListener('click', event => {
      if (!disclosure.contains(event.target)) closeDesktop();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && disclosure.open) {
        closeDesktop();
        summary?.focus({ preventScroll: true });
      }
    });
  }
  document.querySelectorAll('.mobile-nav-group').forEach(group => {
    const summary = group.querySelector('summary');
    summary?.setAttribute('aria-expanded', String(group.open));
    group.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(group.open)));
  });
  desktop.addEventListener('change', event => {
    if (event.matches) close(mobile);
    else closeDesktop();
  });
  if (window.location.hash === '#recherche') {
    document.querySelector('#catalog-query')?.focus({ preventScroll: true });
  }
})();
